import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  CircularProgress,
} from '@material-ui/core';
import { Warning as WarningIcon, Check as CheckIcon } from '@material-ui/icons';

interface ConfirmationModalProps {
  open: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
  showWarningIcon?: boolean;
  confirmButtonColor?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  title = "Confirm Action",
  message,
  onConfirm,
  onCancel,
  confirmButtonText = "Yes, Proceed",
  cancelButtonText = "Cancel",
  showWarningIcon = true,
  confirmButtonColor = '#4caf50',
  maxWidth = 'sm',
  isLoading = false
}) => {
  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : onCancel}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
      maxWidth={maxWidth}
      fullWidth
    >
      {isLoading && (
        <Box
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(255,255,255,0.7)',
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <DialogTitle id="confirmation-dialog-title">
        <Box display="flex" alignItems="center">
          {showWarningIcon && (
            <WarningIcon color="error" style={{ marginRight: 8 }} />
          )}
          {title}
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      
      <DialogActions>
        <Button
          onClick={onCancel}
          color="default"
          variant="outlined"
          disabled={isLoading}
        >
          {cancelButtonText}
        </Button>
        <Button
          onClick={onConfirm}
          style={{ backgroundColor: confirmButtonColor, color: '#fff' }}
          variant="contained"
          startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : <CheckIcon />}
          autoFocus
          disabled={isLoading}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;